import React from 'react';

import { trackEvent } from '../../../../../shared/services/utils/tracking/tracking.service';
import Modal from '../../../../../shared/components/core-ui/modal/modal.component';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../../../shared/components/core-ui/button/button.component';
import useWindowResizer from '../../../../../shared/hooks/window-resizer/window-resizer.hook';
import { BrokerUiModel } from '../../../../../shared/ui-models/broker.ui-model';

export interface DeleteBrokerModalProps {
  data: {
    broker?: BrokerUiModel;
  };
  config: {
    showModal: boolean;
  };
  eventHandlers: {
    cancelHandler: () => void;
    deleteBrokerHandler: (broker: BrokerUiModel) => void;
  };
}

export const DeleteBrokerModal: React.FC<DeleteBrokerModalProps> = ({
  data,
  config,
  eventHandlers
}) => {
  const isMobileView = useWindowResizer();

  const handleDeleteBrokerSubmit = () => {
    if (data && data.broker) {
      eventHandlers.deleteBrokerHandler(data.broker);
    }
  };

  return (
    <Modal
      config={{ showModal: config.showModal, fullScreen: false, showClose: false }}
      eventHandlers={{
        closeModalHandler: () => {
          eventHandlers.cancelHandler();
        }
      }}
    >
      <div className="flex flex-col gap-3 px-6 py-4">
        <div className="text-2xl font-gilroy-bold font-semibold text-neutral-900">
          Delete Broker
        </div>
        <div className="text-xl font-gilroy-medium text-neutral-500">
          {`Are you sure you want to delete ${data.broker?.name}?`}
        </div>
        {/*
          The delete is soft on the server, so reservations already credited to
          this broker keep naming them. Said here because "delete" on its own
          reads as though that history goes too.
        */}
        <div className="text-lg font-gilroy-medium text-neutral-400">
          Reservations already credited to this broker keep their record. The broker stops appearing
          when creating new reservations.
        </div>
      </div>
      <div className="flex flex-col gap-3 px-6 pb-6 sm:flex-row sm:justify-end">
        <Button
          onClick={() => {
            eventHandlers.cancelHandler();
            trackEvent('record_edit_cancelled', { entity: 'broker', method: 'cancel' });
          }}
          tracking={{ event: 'record_edit_cancelled', entity: 'broker', method: 'cancel' }}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
          type={ButtonType.primaryInverted}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeleteBrokerSubmit}
          tracking={{
            event: 'record_saved',
            entity: 'broker',
            action: 'update',
            outcome: 'success'
          }}
          type={ButtonType.danger}
          size={isMobileView ? ButtonSize.full : ButtonSize.medium}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};
